import React from 'react';
import { useCbsSubscriptionDetails } from '~/src/hooks/cbs/useCbsSubscriptionDetails';

import { CurrentPlanOverview } from './CurrentPlanOverview';
import { BillingCycleCard } from '~/src/pages/Settings/subpages/SettingsSubscription/SettingsCbsSubscription/BillingCycle';
import { LicenseQuantityCard } from '~/src/pages/Settings/subpages/SettingsSubscription/SettingsCbsSubscription/LicenseQuantity';
import { CourtFormsAddOnCard } from '~/src/pages/Settings/subpages/SettingsSubscription/SettingsCbsSubscription/CourtFormsAddOn';
import { PaymentInfoCard } from '~/src/pages/Settings/subpages/SettingsSubscription/SettingsCbsSubscription/PaymentInfo';
import { BusinessEntityCard } from '~/src/pages/Settings/subpages/SettingsSubscription/SettingsCbsSubscription/TaxIdentifier';
import PlanChangeCard from '~/src/pages/Settings/subpages/SettingsSubscription/SettingsCbsSubscription/PlanUpgrade/PlanChangeCard';

export const SubscriptionDetails = ({ pendingRequest, subscription }) => {
  const { data: subscriptionDetails } = useCbsSubscriptionDetails();
  const hasReseller = subscriptionDetails?.has_reseller;

  return (
    <div
      className="flex flex-col gap-6 mx-auto max-w-full"
      style={{ maxWidth: '640px' }}
    >
      {/* Current Plan Overview with Payment Details */}
      <CurrentPlanOverview
        subscription={subscription}
        pendingRequest={pendingRequest}
      />

      {/* Subscription Management Cards - Only show if not reseller */}
      {!hasReseller && (
        <>
          <PaymentInfoCard subscription={subscription} />

          <BillingCycleCard subscription={subscription} />

          <LicenseQuantityCard subscription={subscription} />

          <CourtFormsAddOnCard subscription={subscription} />

          <PlanChangeCard subscription={subscription} />
        </>
      )}

      <BusinessEntityCard />

      {/* Help Footer */}
      {subscription && (
        <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-600 text-center">
          <p>
            <strong>Need help?</strong> For subscription questions, please
            contact Clio support.
          </p>
        </div>
      )}
    </div>
  );
};
